import { useEffect, useRef } from "react";
import type { RoundListItem } from "../../shared/contracts/product-pages.js";
import { loadRoundSnapshot } from "../api/round-api.js";
import { roundListItemOf } from "../lib/round-view.js";
import { toast } from "@/components/ui/sonner";
import { useResultLink } from "./use-result-link.js";

/** Opening evidence rechecks current access; an old account cannot reopen it. */
export function useRoundSource(
  accountId: string,
  onOpen: (round: RoundListItem) => void,
  enabled = true,
): (id: string) => void {
  const latest = useRef({ accountId, request: 0 });
  latest.current.accountId = accountId;
  useEffect(
    () => () => {
      latest.current.request += 1;
    },
    [accountId],
  );
  const open = (id: string) => {
    const request = ++latest.current.request;
    void loadRoundSnapshot(id)
      .then((snapshot) => {
        if (
          latest.current.accountId === accountId &&
          latest.current.request === request
        )
          onOpen(roundListItemOf(snapshot));
      })
      .catch((error: unknown) => {
        if (
          latest.current.accountId === accountId &&
          latest.current.request === request
        )
          toast.error(
            error instanceof Error
              ? error.message
              : "The source round could not load.",
          );
      });
  };
  useResultLink(accountId, enabled, open);
  return open;
}
